import { language as lan_shopifyConnection } from "./shopify";

let language = {
    ...lan_shopifyConnection,

    "A116B001": "This store has already been claimed. If you are the owner of this store and it's not listed in your account, please contact us for assistance.",

    // 公共-店铺链接
    CONNECT_ALREADY_HAVE_ACCOUNT: "You already have an account. Continue with your",
    CONNECT_USER_EMAIL: "{{userMail}}",
    CONNECT_CONTINUE_BTN: "Continue",
    CONNECT_CONNECT_TO_SHOPIFY_TEXT: "Connect {{appName}} to {{storeType}}",
    CONNECT_NEW_TO_SITE_TEXT: "New To {{appName}} ?",
    CONNECT_SIGNUP_LINK: "Sign Up",
    CONNECT_ALREADY_HAVA_ACCOUNT_QUESTION_TEXT: "Already have an account?",
    CONNECT_SIGNIN_LINK: "Sign In",
    CONNECT_CONFIRM_CONNECTION_TEXT: "Confirm connection",
    CONNECT_CONNECT_STORE_TO_USER_TEXT: "Connect store to {{userMail}}",
    CONNECT_SIGNIN_DIFFERENT_ACCOUNT: "Sign in a different account",
    CONNECT_CONNECT_URL_INVALID_PARAM_TITLE:"Invalid URL",
    CONNECT_CONNECT_URL_INVALID_PARAM_CONTENT:"Missing parameters: {{missingField}} in store connection page URL. Please return to the {{platformName}} and try again. If you need further assistance, feel free to contact our support team at {{supportmail}}.",
    CONNECT_CONNECT_CREATE_STORE_ISSUE_TITLE:"Create store issue",
    CONNECT_CONNECT_CREATE_STORE_ISSUE_CONTENT:"An error occurred while trying to create store. Please try again. If the issue persists, contact our support team at {{supportmail}}.",
    CONNECT_CONNECT_WOO_STORE_AUTHORIZATION_ISSUE_TITLE:"Store Authorization Exception",
    CONNECT_CONNECT_WOO_STORE_AUTHORIZATION_ISSUE_CONTENT:"The store has been successfully created, but there is an issue with the WooCommerce authorization page. Please complete store authorization later."
};

export { language }